export default __webpack_public_path__ + "static/media/volunteer4.c7f620ee.jpg";